module.exports = __webpack_public_path__ + "static/media/home.8d9cc120.png";